module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Anchor-center-down-36f00ac98adc37420ac94645924b4720.svg";